/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { useObserver } from "mobx-react-lite";
import {
  useAppInsightsContext,
  useTrackMetric,
} from "@microsoft/applicationinsights-react-js";
import DashboardTabs from "../Dashboard/DashboardTabs";
import { AppInsightsConstants } from "../../Constants";
import { AppInsightMethods } from "../../AppInsightMethods";
import { useGlobalStore } from "../../state/GlobalStore";
import SystemSettings from "./SystemSettings";
import MeetingSettings from "./MeetingSettings";

export default function General() {
  const pageName = "General";
  const appInsights = useAppInsightsContext();
  const [value, setValue] = useState("System Settings");
  const globalStore = useGlobalStore();
  const [searchText, setSearchText] = useState("");
  const trackComponent = useTrackMetric(appInsights, pageName);

  useEffect(() => {
    trackComponent();
  }, []);

  return useObserver(() => {
    return (
      <Grid>
        <DashboardTabs
          parentTabName={pageName}
          selectedSubTab={value}
          handleTabChange={(e: any, newValue: string) => {
            setValue(newValue);
            AppInsightMethods.trackAppInsightsEvent(
              pageName,
              AppInsightsConstants.Information,
              `The "${newValue}" tab has been clicked on the ${pageName} section.`,
              globalStore.loginUserEmail,
              window.location.href,
              ""
            );
          }}
          searchText={searchText}
          setSearchText={(val: string) => setSearchText(val)}
        />
        {value === "System Settings" && (
          <SystemSettings searchString={searchText} />
        )}
        {value === "Meeting Settings" && (
          <MeetingSettings searchString={searchText} />
        )}
      </Grid>
    );
  });
}
